import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Button, Card, CardHeader, CardContent } from '@material-ui/core';

const CustomCard = ({ classes, title, avatar, onEdit, children }) => {
  return (
    <Card classes={{ root: classes.card }}>
      {title && title.length && (
        <CardHeader
          title={title}
          avatar={
            avatar && (
              <Avatar aria-label="avatar" data-testid="avatar" className={classes.avatar}>
                {avatar}
              </Avatar>
            )
          }
          action={
            onEdit && (
              <Button onClick={onEdit} className={classes.btn} aria-label="edit" data-testid="edit-btn">
                Edit
              </Button>
            )
          }
          classes={{ root: classes.header, title: classes.title, action: classes.action }}
        />
      )}
      <CardContent classes={{ root: classes.content }}>{children}</CardContent>
    </Card>
  );
};

CustomCard.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  /** The content of the Card Title. */
  title: PropTypes.string,
  /** The Avatar for the Card Header. */
  avatar: PropTypes.node,
  /** Callback for edit button. */
  onEdit: PropTypes.func,
  /** The content of Card Content. */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

CustomCard.defaultProps = {
  classes: {},
  title: '',
};

export default CustomCard;
